(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1835],{

/***/ 1887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(92310);

/***/ }),

/***/ 83982:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/videa/[slug]",
      function () {
        return __webpack_require__(80235);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useGetAuthorOverview; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97478);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99167);




var P = "authorOverview";
var queryKeys = {
    get: function(slug) {
        return [
            P,
            slug
        ];
    }
};
var fetchAuthorOverview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api__WEBPACK_IMPORTED_MODULE_1__/* .authFetch */ .SH(_api__WEBPACK_IMPORTED_MODULE_1__/* .authorOverviewUrl */ .Px(slug))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        throw Error("Nepodarilo sa nač\xedtať lektora");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchAuthorOverview(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useGetAuthorOverview = function(slug, enabled) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKeys.get(slug), function() {
        return fetchAuthorOverview(slug);
    }, {
        enabled: enabled
    });
};


/***/ }),

/***/ 26221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1887);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39321);




var Head = function(param) {
    var title = param.title, description = param.description, url = param.url, imageUrl = param.imageUrl, imageAlt = param.imageAlt, noIndex = param.noIndex;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:site_name",
                content: "Street of Code"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:site",
                content: "@StreetofCode1"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:locale",
                content: "sk_SK"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: imageUrl || _constants__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_LOGO_IMAGE_URL */ .PX
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image:alt",
                content: imageAlt || title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "google-site-verification",
                content: "FB24EUCOSSYhz39LdPTSNW4Yebc0El71AV7luRQcQQc"
            }),
            noIndex && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "robots",
                content: "noindex"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 41246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  align-self: center;\n  padding: 50px 32px 100px 32px;\n  width: clamp(320px, 100%, 1200px);\n\n  @media ",
        " {\n    max-width: 900px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PageContentWrapper = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: className
    }, props), {
        children: children
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db8ecefa-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.L */ .U.L);
/* harmony default export */ __webpack_exports__["Z"] = (PageContentWrapper);


/***/ }),

/***/ 23244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var _core_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43195);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10447);
/* harmony import */ var _api_authorOverview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76231);
/* harmony import */ var _QueryGuard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10229);
/* harmony import */ var _core_Avatar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72463);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81990);
/* harmony import */ var _images__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91195);
/* harmony import */ var _core_Flex__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90656);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80371);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12691);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_10__);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 20px;\n  padding: 10px;\n\n  transition: 250ms ease-in-out;\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: 1px 8px 20px var(--color-shadow);\n    transform: scale(1.1);\n    transition: 250ms ease-in-out;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 4px;\n  align-items: flex-start;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  opacity: 0.6;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var AUTHOR_SLUG = {
    "Jakub Jahič": "jakub-jahic",
    "Gabriel Kerekeš": "gabriel-kerekes"
};
var PodcastAuthorAndDate = function(param) {
    var date = param.date;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
        href: _routes__WEBPACK_IMPORTED_MODULE_9__/* .routes.root */ ._.root,
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(StyledHyperlink, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(FlexWrapper, {
                alignItems: "center",
                gap: "8px",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_core_Avatar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        altName: "Street of Code logo",
                        src: _images__WEBPACK_IMPORTED_MODULE_7__/* .socLamp */ .WM,
                        sizePx: 38
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(NameAndDateFlexWrapper, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_core_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                size: "small",
                                children: "Street of Code"
                            }),
                            date && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(DateText, {
                                size: "small",
                                children: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(new Date(date))
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var ArticleAuthorAndDate = function(param) {
    var date = param.date, authorName = param.authorName;
    var authorSlug = authorName ? AUTHOR_SLUG[authorName] : "";
    var getAuthorOverviewQuery = (0,_api_authorOverview__WEBPACK_IMPORTED_MODULE_4__/* .useGetAuthorOverview */ .N)(authorSlug);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_QueryGuard__WEBPACK_IMPORTED_MODULE_5__/* .QueryGuard */ .l, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, getAuthorOverviewQuery), {
        children: function(authorOverview) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                href: _routes__WEBPACK_IMPORTED_MODULE_9__/* .routes.lektor.slug */ ._.lektor.slug(authorSlug),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(StyledHyperlink, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(FlexWrapper, {
                        alignItems: "center",
                        gap: "8px",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_core_Avatar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                altName: authorOverview.name,
                                src: authorOverview.imageUrl,
                                sizePx: 38
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(NameAndDateFlexWrapper, {
                                direction: "column",
                                children: [
                                    authorName && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_core_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        size: "small",
                                        children: authorOverview.name
                                    }),
                                    date && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(DateText, {
                                        size: "small",
                                        children: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(new Date(date))
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        }
    }));
};
var AuthorAndDate = function(param) {
    var date = param.date, authorName = param.authorName, isPodcastOrVideo = param.isPodcastOrVideo;
    if (isPodcastOrVideo) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(PodcastAuthorAndDate, {
        date: date
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(ArticleAuthorAndDate, {
        date: date,
        authorName: authorName
    });
};
var FlexWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_core_Flex__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f9e959a2-0"
})(_templateObject());
var NameAndDateFlexWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_core_Flex__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f9e959a2-1"
})(_templateObject1());
var DateText = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_core_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f9e959a2-2"
})(_templateObject2());
var StyledHyperlink = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-f9e959a2-3"
})(_templateObject3());
/* harmony default export */ __webpack_exports__["Z"] = (AuthorAndDate);


/***/ }),

/***/ 80235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var _components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41246);
/* harmony import */ var _components_NavBar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55270);
/* harmony import */ var _components_Head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26221);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80371);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81990);
/* harmony import */ var _components_core_Flex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90656);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40592);
/* harmony import */ var _components_domain_post_AuthorAndDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23244);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    align-self: left;\n    align-items: flex-start;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: clamp(320px, 100%, 750px);\n  margin: 0 auto;\n\n  @media (max-width: 610px) {\n    iframe {\n      width: 400px;\n      height: 225px;\n    }\n  }\n\n  @media (max-width: 450px) {\n    iframe {\n      width: 320px;\n      height: 180px;\n    }\n  }\n\n  @media ",
        " {\n    iframe {\n      width: 240px;\n      height: 135px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 42px;\n  font-weight: bold;\n  color: var(--color-secondary);\n\n  @media ",
        " {\n    font-size: 32px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 100%;\n\n  line-height: 1.6em;\n  font-size: 18px;\n  font-weight: 100;\n\n  color: var(--color-secondary);\n\n  p:first-of-type {\n    margin-top: 0;\n  }\n\n  p {\n    width: 100%;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0;\n\n    audio {\n      margin: 14px 0;\n    }\n\n    > * {\n      max-width: 100%;\n    }\n  }\n\n  h2 {\n    margin-top: 40px;\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var videoDescriptionToHTML = function(description) {
    var isUrl = function(text) {
        try {
            // eslint-disable-next-line no-new
            new URL(text);
            return true;
        } catch (_) {
            return false;
        }
    };
    var wrapLinksInAnchorTags = function(descriptionLine) {
        var descriptionLineWithLinks = descriptionLine.split(" ").map(function(word) {
            if (isUrl(word)) {
                return '<a href="'.concat(word, '">').concat(word, "</a>");
            }
            return word;
        }).join(" ");
        return descriptionLineWithLinks;
    };
    var wrapLineInParagraph = function(descriptionLine) {
        // empty paragraphs' margins are not rendered in browser so we need to replace them with at least non-breaking space
        if (descriptionLine === "") {
            return "<p>&nbsp;</p>";
        }
        return "<p>".concat(descriptionLine, "</p>");
    };
    return description.split("\n").map(wrapLinksInAnchorTags).map(wrapLineInParagraph).join("");
};
var SingleVideoPage = function(param) {
    var video = param.video;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_Head__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "".concat(video.snippet.title || "Video", " | Street of Code"),
                description: video.snippet.description || "Toto je video, ktor\xe9 nem\xe1 poriadny popis. Ups, pard\xf3n, dopln\xedme.",
                url: (0,_routes__WEBPACK_IMPORTED_MODULE_5__/* .prefixWithHost */ .O)(_routes__WEBPACK_IMPORTED_MODULE_5__/* .routes.videa.slug */ ._.videa.slug(video.id || "")),
                imageUrl: video.snippet.thumbnails.medium.url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_NavBar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(FlexWrapper, {
                    direction: "column",
                    gap: "12px",
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(StyledPostTitle, {
                            children: video.snippet.title
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(AuthorAndTagsWrapper, {
                            gap: "16px",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(AuthorAndDateWrapper, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_domain_post_AuthorAndDate__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    date: video.snippet.publishedAt.value || undefined,
                                    authorName: "Street of Code" || 0,
                                    isPodcastOrVideo: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(PostContent, {
                            dangerouslySetInnerHTML: {
                                __html: videoDescriptionToHTML(video.snippet.description)
                            }
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("iframe", {
                            width: "560",
                            height: "315",
                            src: "https://www.youtube.com/embed/".concat(video.id),
                            title: "YouTube video player",
                            frameBorder: "0",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                            allowFullScreen: true
                        })
                    ]
                })
            })
        ]
    });
};
var AuthorAndTagsWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5fd1eee4-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.S */ .U.S);
var FlexWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5fd1eee4-1"
})(_templateObject1(), _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.XS */ .U.XS);
var AuthorAndDateWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5fd1eee4-2"
})(_templateObject2());
// Special case when we don't want tu use our Heading component
var StyledPostTitle = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-5fd1eee4-3"
})(_templateObject3(), _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.S */ .U.S);
var PostContent = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5fd1eee4-4"
})(_templateObject4());
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (SingleVideoPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7138,5270,9774,2888,179], function() { return __webpack_exec__(83982); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);